"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncExport = _interopRequireWildcard(require("./components/asyncExport"));
var _asyncImport = _interopRequireDefault(require("./components/asyncImport"));
var _checkboxGroup = _interopRequireDefault(require("./components/checkboxGroup"));
var _dateRangePicker = _interopRequireDefault(require("./components/dateRangePicker"));
var _dateTimeRangePicker = _interopRequireDefault(require("./components/dateTimeRangePicker"));
var _filesDownload = _interopRequireDefault(require("./components/filesDownload"));
var _fixedBottomActions = _interopRequireDefault(require("./components/fixedBottomActions"));
var _image = require("./components/image");
var _import = _interopRequireDefault(require("./components/import"));
var _infiniteSelect = _interopRequireDefault(require("./components/infiniteSelect"));
var _inputRange = _interopRequireDefault(require("./components/inputRange"));
var _listSort = _interopRequireDefault(require("./components/listSort"));
var _monthRange = _interopRequireDefault(require("./components/monthRange"));
var _provider = _interopRequireDefault(require("./components/provider"));
var _quarterRange = _interopRequireWildcard(require("./components/quarterRange"));
var _searchForm = _interopRequireDefault(require("./components/searchForm"));
var _select = _interopRequireDefault(require("./components/select"));
var _table = _interopRequireDefault(require("./components/table"));
var _tableLayout = _interopRequireDefault(require("./components/tableLayout"));
var _upload = _interopRequireDefault(require("./components/upload"));
var _yearRange = _interopRequireDefault(require("./components/yearRange"));
const components = {
  Provider: _provider.default,
  Table: _table.default,
  ListSort: _listSort.default,
  TableLayout: _tableLayout.default,
  SearchForm: _searchForm.default,
  InfiniteSelect: _infiniteSelect.default,
  Select: _select.default,
  InputRange: _inputRange.default,
  DateRangePicker: _dateRangePicker.default,
  QuarterPicker: _quarterRange.QuarterPicker,
  QuarterRange: _quarterRange.default,
  FixedBottomActions: _fixedBottomActions.default,
  MonthRange: _monthRange.default,
  Image: _image.Image,
  ImagePreview: _image.ImagePreview,
  YearRange: _yearRange.default,
  AsyncImport: _asyncImport.default,
  Upload: _upload.default,
  CheckboxGroup: _checkboxGroup.default,
  Import: _import.default,
  FilesDownload: _filesDownload.default,
  DateTimeRangePicker: _dateTimeRangePicker.default,
  AsyncExport: _asyncExport.default,
  AsyncExportTable: _asyncExport.AsyncExportTable
};
var _default = exports.default = {
  ...components,
  install(Vue) {
    Object.values(components).forEach(component => {
      Vue.component(component.name, component);
    });
  }
};